import { hbs } from 'ember-cli-htmlbars';
export default hbs("<Layout::Section::Wrapper>\n  <Ui::LoadingSpinner />\n</Layout::Section::Wrapper>")